import { Fragment } from "react";
import Fade from "react-reveal/Fade";
import RepresentativeApplicantCompany from "./components/RepresentativeApplicantCompany";

function Companies({ rolBase }) {
  return (
    <Fade right>
      <div style={{ width: "100%" }}>
        <RepresentativeApplicantCompany />
      </div>
    </Fade>
  );
}

export default Companies;

